import LazyLoadWrapper from './LazyLoadWrapper';

export { default as LazyLoadComponents } from './LazyLoadComponents';

export default LazyLoadWrapper;
